export default "__VITE_ASSET__D3Dxsrnd__"